import { formatNumber } from '@makemydeal/dr-common-utils';

import type { AppliedFilter, AppliedFilterTag, AppliedInputFilter, VehicleSearchV2FilterQueryParams } from '../types';
import { FilterGroupTypes } from '../types';

export const formatNumericFilterLabel = (appliedFilter: AppliedInputFilter): string => {
    const prefix = appliedFilter.prefix || '';
    const suffix = appliedFilter.suffix ? ` ${appliedFilter.suffix}` : '';

    return prefix + formatNumber(Number(appliedFilter.value)) + suffix;
};

export const formatInputFilterLabel = (appliedFilter: AppliedInputFilter): string => {
    return `${appliedFilter.label} ${formatNumericFilterLabel(appliedFilter)}`;
};

export const formatRangeFilterLabel = ([leftBound, rightBound]: AppliedInputFilter[]): string => {
    const left = formatNumericFilterLabel(leftBound);
    const right = formatNumericFilterLabel(rightBound);

    return `${left} - ${right}`;
};

export const getSelectedFilterTags = (selectedFilters: AppliedFilter[]): AppliedFilterTag[] => {
    const filterTags: AppliedFilterTag[] = [];

    selectedFilters.forEach((appliedFilterItem) => {
        if (appliedFilterItem.type === FilterGroupTypes.INPUT) {
            const leftBoundTag = filterTags.find((tag) => tag.groupId === appliedFilterItem.id);

            if (leftBoundTag) {
                leftBoundTag.appliedFilters.push(appliedFilterItem);
                leftBoundTag.tagLabel = formatRangeFilterLabel(leftBoundTag.appliedFilters as AppliedInputFilter[]);
                return;
            }

            filterTags.push({
                tagLabel: formatInputFilterLabel(appliedFilterItem),
                appliedFilters: [appliedFilterItem],
                groupId: appliedFilterItem.id
            });
        }

        if (appliedFilterItem.type === FilterGroupTypes.CHECKBOX) {
            filterTags.push({
                tagLabel: appliedFilterItem.label,
                appliedFilters: [appliedFilterItem],
                groupId: appliedFilterItem.id
            });
        }
    });

    return filterTags;
};

export const getFilterQueryValue = (appliedFilter: AppliedFilter) =>
    appliedFilter.type === FilterGroupTypes.INPUT ? appliedFilter.value : appliedFilter.label;

export const mapAppliedFiltersToQueryParams = (appliedFilters: AppliedFilter[]): VehicleSearchV2FilterQueryParams => {
    return appliedFilters.reduce((queryParams, appliedFilter) => {
        const paramKey = appliedFilter.queryParameter as keyof VehicleSearchV2FilterQueryParams;
        const existingValues = queryParams[paramKey];
        const queryValue = getFilterQueryValue(appliedFilter);

        return {
            ...queryParams,
            [paramKey]: existingValues ? `${existingValues},${queryValue}` : queryValue
        };
    }, {} as VehicleSearchV2FilterQueryParams);
};
